<template>
    <div>
        <form-group label="Date" name="date" :required="true">
            <datepicker v-model="expense.date" :max-date="maxDate" :disableWeekends="disableWeekends" ref="test" />
        </form-group>

        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2">
                <form-group :label="amountLabel" name="amount.0" :required="true">
                    <div class="flex">
                        <div class="select">
                            <select class="input w-16" v-model="expense.amount[0]">
                                <option v-for="hour in hours" :value="hour">{{ hour }}</option>
                            </select>
                        </div>
                        <div class="input-group-addon">:</div>
                        <div class="select">
                            <select class="input text-left w-16" v-model="expense.amount[1]">
                                <option v-for="minute in minutes" :value="minute">{{ minute }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="help-text text-red" v-if="hasError('amount')" v-html="getError('amount')"></div>
                    <div class="help-text text-red" v-if="hasError('amount.1')" v-html="getError('amount.1')"></div>
                </form-group>
            </div>
        </div>

        <form-group label="Attachments" name="attachments" :required="false">
            <file-upload :url="fileUploadUrl"
                         :deleteUrl="fileDeleteUrl"
                         v-model="expense.attachments"
                         @activeFileUpload="$emit('activeFileUpload', $event)">
            </file-upload>
        </form-group>

    </div>
</template>

<script>

import {mapState} from "vuex";
import Form from './form';
import InteractsWithDates from '@/mixins/InteractsWithDates';
import FileUpload from "@/components/DragUpload";

export default {
    mixins: [Form, InteractsWithDates],

    components: {
        FileUpload
    },

    props: ['value', 'expenseType', 'fileUploadUrl', 'fileDeleteUrl'],

    data() {
        return {
            expense: {
                ...{ amount: [0, 0]},
                ...this.value,
            },
            currencies: [],
            hours: _.range(0, 24),
            minutes: _.range(0, 60, 5)
        }
    },

    computed: {
        ...mapState(['employee']),

        amountLabel() {
            return `Number of Hours ${this.expenseType === 'Night Time Allowance' ? '(22-06)' : '' }`;
        },

        disableWeekends() {
            return this.expenseType === 'Night Time Allowance';
        }
    },
}
</script>
